__turbopack_context__.v({
  "className": "titillium_web_d1363a6a-module__EwtD3W__className",
  "variable": "titillium_web_d1363a6a-module__EwtD3W__variable",
});
